import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  Videocam as VideoCamIcon,
  CloseRounded as CloseIcon,
} from "@material-ui/icons";
import BusinessIcon from "@material-ui/icons/Business";
// import DeviceHubIcon from "@material-ui/icons/DeviceHub";
import { ReactComponent as Logo } from "./../../assets/svg/Logo.svg";
import { ReactComponent as ToggleIcon } from "./../../assets/svg/toggle-icon.svg";
import UserProfileIcon from "../../components/common/UserProfileIcon";
import HeaderSearchBar from "../../pages/SearchAndConnect/components/HeaderSearchBar";
import { get, isEmpty } from "lodash";
import appRoutes from "../../routes/app.routes";
import { useSelector } from "react-redux";
import { rootReducersState } from "../../reducers";
import HomeIcon from "@material-ui/icons/Home";
import PeopleAltIcon from "@material-ui/icons/PeopleAlt";
import BusinessCenterIcon from "@material-ui/icons/BusinessCenter";
import Notifications from "@material-ui/icons/Notifications";
import { Badge } from "@material-ui/core";
import useSessionUser from "../../hooks/useSessionUser";
import { isSessionMessagingEnabled } from "../../utils/messaging.utils";
import MessageIcon from "@material-ui/icons/Message";
import ContactUsSVG from "../../assets/svg/contactUs";
// import SolutionDropdown from "./SolutionDropdown";
// import IndustryDropdown from "./IndustryDropdown";
// import { ReactComponent as   LearnCodeIcon} from './../../assets/svg/learnCodeIcon.svg';

const _ = { get, isEmpty };
const DefaultHeader = () => {
  const sessionReducer = useSelector(
    ({ session }: rootReducersState) => session
  );
  const tokenUser = _.get(sessionReducer, "currentUser", {});
  const receivedCount = _.get(sessionReducer, "currentUser.receivedCount", 0);
  const notificationCount = _.get(
    sessionReducer,
    "currentUser.notificationCount",
    0
  );
  const candidateMessageCount = _.get(
    sessionReducer,
    "currentUser.candidateMessageCount",
    0
  );
  const [openNav, setOpenNav] = useState(false);
  const location = useLocation();
  const isFeedsRoute = location.pathname.startsWith(appRoutes.Feed.path);
  const { IS_COMPANY } = useSessionUser();
  const sessionMessagingEnabled = isSessionMessagingEnabled(tokenUser);

  const handleMobileMenuClick = () => {
    setOpenNav(!openNav);
  };
  // const handleActiveLink = (isActive: boolean): string =>
  //   isActive ? "active" : "inactive";
  // ...existing code...
  const handleActiveLink = ({ isActive }: { isActive: boolean }): string =>
    isActive ? "active" : "inactive";
  // ...existing code...

  // const [isDropdownVisible, setDropdownVisible] = useState(false);
  // const [isDropdown, setDropdown] = useState(false);

  // Add mobile detection
  // const [isMobile, setIsMobile] = useState(false);

  // useEffect(() => {
  //   const checkMobile = () => {
  //     setIsMobile(window.innerWidth <= 768);
  //   };

  //   checkMobile();
  //   window.addEventListener("resize", checkMobile);

  //   return () => window.removeEventListener("resize", checkMobile);
  // }, []);

  // const handleMouseEnter = () => {
  //   if (!isMobile) {
  //     setDropdownVisible(true);
  //   }
  // };

  // const handleMouseLeave = () => {
  //   if (!isMobile) {
  //     setDropdownVisible(false);
  //   }
  // };

  // const handleMouseEnterEvent = () => {
  //   if (!isMobile) {
  //     setDropdown(true);
  //   }
  // };

  // const handleMouseLeaveEvent = () => {
  //   if (!isMobile) {
  //     setDropdown(false);
  //   }
  // };

  // Add mobile-friendly handlers
  // const handleMobileDropdownToggle = (
  //   dropdownType: "solutions" | "industry"
  // ) => {
  //   if (isMobile) {
  //     if (dropdownType === "solutions") {
  //       setDropdownVisible(!isDropdownVisible);
  //       setDropdown(false); // Close other dropdown
  //     } else {
  //       setDropdown(!isDropdown);
  //       setDropdownVisible(false); // Close other dropdown
  //     }
  //   }
  // };

  // const handleKeyDown = (
  //   e: React.KeyboardEvent,
  //   dropdownType: "solutions" | "industry"
  // ) => {
  //   if (isMobile && (e.key === "Enter" || e.key === " ")) {
  //     e.preventDefault();
  //     handleMobileDropdownToggle(dropdownType);
  //   }
  // };

  // Close dropdowns when switching between mobile and desktop
  // useEffect(() => {
  //   if (!isMobile) {
  //     setDropdownVisible(false);
  //     setDropdown(false);
  //   }
  // }, [isMobile]);

  return (
    <header
      className={`default-navbar loggedin${isFeedsRoute ? " feeds-route" : ""}`}
    >
      <nav className="navbar-expand-lg">
        <span className="navBrand navbar-brand">
          <NavLink to={appRoutes.home.path}>
            <Logo />
          </NavLink>
        </span>

        {/* {![appRoutes.home.path].includes(location.pathname) && ( */}
        {!_.isEmpty(tokenUser) && (
          <>
          <HeaderSearchBar key="desktop-search" className="desktop-search" />
          <HeaderSearchBar key="mobile-search" className="mobile-search" />
          </>
        )}

        {/* )} */}
        <div className="nav-link desktop-navbar-nav" id="desktop-navbar-nav">
          <div className="justify-content-end w-100 navLinks navbar-nav">
            {!IS_COMPANY && (
              <>
                {/* <div className="nav-item mobile-search">
                  {![appRoutes.home.path].includes(location.pathname) &&
                    !_.isEmpty(tokenUser) && (
                      <HeaderSearchBar
                        key={1}
                        searchLabel
                        className="mobile-search"
                      />
                    )}
                </div> */}
                {_.isEmpty(tokenUser) ? (
                  <div className="nav-item">
                    <NavLink
                      to={appRoutes.home.path}
                      // exact
                      className={handleActiveLink}
                    >
                      <span className="icon">
                        <HomeIcon />
                      </span>
                      <span>Home</span>
                    </NavLink>
                  </div>
                ) : (
                  <div className="nav-item">
                    <NavLink
                      to={appRoutes.Feed.path}
                      className={handleActiveLink}
                    >
                      <span className="icon">
                        <HomeIcon />
                      </span>
                      <span>Home</span>
                    </NavLink>
                  </div>
                )}

                {/* {_.isEmpty(tokenUser) && (
                  <div className="nav-item inactive">
                    <div
                      onClick={(e) => {
                        e.preventDefault();
                        if (isMobile) {
                          handleMobileDropdownToggle("solutions");
                        }
                      }}
                      onKeyDown={(e) => handleKeyDown(e, "solutions")}
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                      className={`main-list-wrapper ${
                        isDropdownVisible ? "active" : ""
                      }`}
                    >
                      <span className="icon">
                        <DeviceHubIcon />
                      </span>
                      <div
                        className={`dropdown-wrapper single-column ${
                          isMobile ? "mobile-dropdown" : ""
                        }`}
                      >
                        <span className="menu">
                          <span>Solutions</span>
                        </span>
                        {isDropdownVisible && (
                          <SolutionDropdown
                            onClose={() => setDropdownVisible(false)}
                            isMobile={isMobile}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                )} */}

                {_.isEmpty(tokenUser) && (
                  // <div className="nav-item inactive">
                  //   <div
                  //     onClick={(e) => {
                  //       e.preventDefault();
                  //       if (isMobile) {
                  //         handleMobileDropdownToggle("industry");
                  //       }
                  //     }}
                  //     onKeyDown={(e) => handleKeyDown(e, "industry")}
                  //     onMouseEnter={handleMouseEnterEvent}
                  //     onMouseLeave={handleMouseLeaveEvent}
                  //     className={`main-list-wrapper ${
                  //       isDropdown ? "active" : ""
                  //     }`}
                  //   >
                  //     <span className="icon">
                  //       <BusinessIcon />
                  //     </span>
                  //     <div
                  //       className={`dropdown-wrapper ${
                  //         isMobile ? "mobile-dropdown" : ""
                  //       }`}
                  //     >
                  //       <span className="menu">
                  //         <span>Industry Expertise</span>
                  //       </span>
                  //       {isDropdown && (
                  //         <IndustryDropdown
                  //           onClose={() => setDropdown(false)}
                  //           isMobile={isMobile}
                  //         />
                  //       )}
                  //     </div>
                  //   </div>
                  // </div>

                   <div className="nav-item">
                    <NavLink
                      to={appRoutes.IndustryExpertise.path}
                      // exact
                      className={handleActiveLink}
                    >
                      <span className="icon">
                     <BusinessIcon />
                      </span>
                      <span>Industry Expertise</span>
                    </NavLink>
                  </div>
                )}
                {!_.isEmpty(tokenUser) && (
                  <div className="nav-item">
                    <NavLink
                      to={appRoutes.candidateConnections.path}
                      className={handleActiveLink}
                    >
                      <span className="icon">
                        <PeopleAltIcon />
                      </span>
                      {receivedCount > 0 ? (
                        <Badge
                          className="badge-blue"
                          badgeContent={receivedCount}
                        >
                          <span>Connections</span>
                        </Badge>
                      ) : (
                        <span>Connections</span>
                      )}
                    </NavLink>
                  </div>
                )}
                <div className="nav-item">
                  <NavLink
                    to={appRoutes.candidateJobSearch.path}
                    className={handleActiveLink}
                  >
                    <span className="icon">
                      <BusinessCenterIcon />
                    </span>
                    <span>Careers</span>
                  </NavLink>
                </div>
                    {_.isEmpty(tokenUser) && (
                     <div className="nav-item">
                  <NavLink
                    to={appRoutes.contactUs.generatePath()}
                    className={handleActiveLink}
                  >
                    <span className="icon">
                      <ContactUsSVG />
                    </span>
                    <span>Contact Us </span>
                  </NavLink>
                </div>
                )}
                   
                {!_.isEmpty(tokenUser) && (
                  <div className="nav-item">
                    <NavLink
                      to={appRoutes.candidateVideos.path}
                      className={`video-studio ${handleActiveLink}`}
                    >
                      <VideoCamIcon /> <span>Video Studio</span>
                    </NavLink>
                  </div>
                )}
                {!_.isEmpty(tokenUser) && sessionMessagingEnabled && (
                  <div className="nav-item">
                    <NavLink
                      to={appRoutes.candidateMessages.altPath}
                      className={handleActiveLink}
                    >
                      <span className="icon">
                        <MessageIcon />
                      </span>
                      {candidateMessageCount > 0 ? (
                        <Badge
                          className="badge-blue-message"
                          badgeContent={candidateMessageCount}
                        >
                          <span>Messages</span>
                        </Badge>
                      ) : (
                        <span>Messages</span>
                      )}
                    </NavLink>
                  </div>
                )}
              </>
            )}
            {IS_COMPANY && (
              <div className="nav-item">
                <NavLink to={appRoutes.Feed.path} className={handleActiveLink}>
                  <span className="icon">
                    <HomeIcon />
                  </span>
                  <span>Home</span>
                </NavLink>
              </div>
            )}
            {!_.isEmpty(tokenUser) && (
              <div className="nav-item">
                <NavLink
                  to={appRoutes.connectionNotifications.path}
                  className={handleActiveLink}
                >
                  <span className="icon">
                    <Notifications />
                  </span>
                  {notificationCount > 0 ? (
                    <Badge
                      className="badge-blue"
                      badgeContent={notificationCount}
                    >
                      <span>Notifications</span>
                    </Badge>
                  ) : (
                    <span>Notifications</span>
                  )}
                </NavLink>
              </div>
            )}
            <UserProfileIcon key="default-header" />
          </div>
        </div>
        <button
          onClick={handleMobileMenuClick}
          aria-controls="responsive-navbar-nav"
          type="button"
          aria-label="Toggle navigation"
          className="navbar-toggler mobile-nav-icon collapsed"
        >
          <span className="navbar-toggler-icon">
            {openNav ? <CloseIcon /> : <ToggleIcon />}
          </span>
        </button>
      </nav>
    </header>
  );
};

export default DefaultHeader;
